import React, {Component} from 'react'
import {Button, Pagination} from 'antd'
import {Link} from "react-router-dom"
import queryString from "qs"
import {_convertObject} from "../../../helpers/convertObject"
import BatchesTable from './table/BatchesTable'
import BatchesFilters from './filters/BatchesFilters'
import {listBatchesV4, exportBatchItems, exportBatchs, exportBatchItemQuantity, getListMaterial} from "../../../services/api/3dApi"
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import { getListBrand } from '../../../services/api/3dApi'
import moment from 'moment'

class BatchesPage extends Component {
    state = {
        batches: [],
        total: 0,
        limit: 50,
        page: 1,
        loading: false,
        error: '',
        filters: {
            name: '',
            partner: '',
            sewing_partner: '',
            level: '',
            overTimeIn: '',
            overTimeEp: '',
            product_types: [],
            user_create: '',
            status: '',
            batch_overtime: [],
            mex: '',
            sewed : 'all',
            delivered: '',
            note:'',
        },
        listBrand: [],
        listMaterials: [],
        total_items_without_moved: 0,
    }

    componentDidMount() {
        const {typeOverTime, status, name} = this.props
        const today = moment().endOf('day').format("DD/MM/YYYY HH:mm") // Lấy ngày hôm nay, thời gian hiện tại
        const threeMonthsAgo = moment().subtract(90, "days").startOf("day").format("DD/MM/YYYY HH:mm") // 3 tháng trước, thời gian 00:00
        const objOvertime = typeOverTime !== undefined && this._convertOvevetime(typeOverTime)
        const arrayName = !!name ? name.split(',') : []
        this._getListBrand()
        this._fetchListMaterials()
        this.setState(({filters}) => {
            if(today && threeMonthsAgo) {
                filters.created_at = {
                    from: threeMonthsAgo, to: today,
                    date: { from: threeMonthsAgo.split(' ')[0], to: today.split(' ')[0] },
                    time: { from: threeMonthsAgo.split(' ')[1], to: today.split(' ')[1] }
                }
            }
            
            return {
                filters: {
                    ...filters,
                    ...objOvertime,
                    status: status ? status : '',
                    name: arrayName.length > 0 ? arrayName : '',
                },
                page: 1
            }
        }, this._fetchBatches)
    }

    _convertOvevetime = (field) => {
        return {
            [field]: {from: 0, phase_status: "not_completed"},
        }
    }

    _fetchListMaterials = async () => {
        try {

            const { data: res } = await getListMaterial({ limit: 10000 })
            const { data, success, message } = res
            if (!success) {
                return this.setState({
                    error : message
                })
            }

            this.setState({
                listMaterials: data.data || []
            })
        } catch (error) {
            this.setState({
                error : error.message
            })
        }
    }

    _fetchBatches = async () => {
        const {requestCount} = this.state
        const nextCount = requestCount ? requestCount + 1 : 1

        this.setState({
            loading: true,
            requestCount: nextCount
        })

        try {
            const {limit, page, filters, listMaterials} = this.state
            let sewing_time = ''
            if (filters.hasOwnProperty('sewing_time_type')) {
                switch (filters.sewing_time_type) {
                    case 'received_1d':
                        sewing_time = {from: 0, to: 24}
                        break
                    case 'received_2d':
                        sewing_time = {from: 24, to: 48}
                        break
                    case 'received_3d':
                        sewing_time = {from: 48, to: 72}
                        break
                    case 'received_4d':
                        sewing_time = {from: 72}
                        break
                    case 'not_received':
                        sewing_time = 'not_received'
                        break
                    default:
                        sewing_time = ''
                }
            }

            let arrMaterial = []
            if(!!filters.materials && Array.isArray(filters.materials) && filters.materials.length){
                filters.materials.forEach(item => {
                    const material = listMaterials.find(i => i.name === item) || {}
                    const code = !!material.code ? material.code : ''
                    arrMaterial.push(`${code} - ${item}`)
                })

                arrMaterial.push(...filters.materials)
            }else{
                !!filters.materials && filters.materials.length && arrMaterial.push(filters.materials)
            }
        
            let payload = {
                ...filters,
                limit,
                sewing_time,
                page: page,
                product_types: filters.product_types,
            }

            if(!!arrMaterial && arrMaterial.length) payload.materials = arrMaterial

            if (!!filters.name && filters.name.length > 0 && filters.name[0] !== '') {
                payload = Object.assign(payload, {name: {'$in': filters.name}})
            }

            if(!!filters && !!filters.tags && filters.tags.some(i => i === "fba")) {
                payload.tags = [...filters.tags, 'FBA']
            }else{
                payload.tags =filters.tags
            }

            const newFilter = _convertObject(payload)

            const {data: response} = await listBatchesV4(newFilter)
            const {data, success, error} = response

            if (nextCount !== this.state.requestCount) {
                return
            }

            if (!success) {
                this.setState({
                    error: error,
                    loading: false
                })
            }

            const {batches, total, total_items_without_moved} = data

            this.setState({
                batches,
                total,
                loading: false,
                error: '',
                total_items_without_moved,
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _getListBrand = async() => {
        const payload = {
            limit:10000,
            page:1
        }
        try {
            const {data:Data}= await getListBrand(payload)
            const {data, success, message}= Data
            const Brands= data.Brands.map(i=>({value:i.name, label:i.name}))
            if(success){
                this.setState({...this.state, listBrand:Brands})
            }else{
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    _handleChangeInput = (field, value) => {
        this.setState(({filters}) => {
            return {
                filters: {
                    ...filters,
                    [field]: value
                },
                page: 1
            }
        }, this._fetchBatches)
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1
        }, this._fetchBatches)
    }

    _handleChangeProductType = (value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                product_types: value
            },
            page: 1
        }, this._fetchBatches)
    }

    _handleChangeMaterials = (value) => {
        const {filters} = this.state
            this.setState({
                filters: {
                    ...filters,
                    materials: value
                },
                page: 1
            }, this._fetchBatches)
    }

    _handleChangeDate = (filters) => {
        this.setState({
            filters: {
                ...filters,
            },
            page: 1
        }, this._fetchBatches)
    }

    _handlePageChange = (page) => {
        this.setState({
            page: page
        }, this._fetchBatches)
    }

    _handleChangeDelivered = (value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                delivered: value
            },
            page: 1
        }, this._fetchBatches)
    }

    _handleChangePartner = (value) => {
        const {filters} = this.state

        this.setState({
            filters: {
                ...filters,
                partner: value
            },
            page: 1
        }, this._fetchBatches)
    }

    _exportAllItemBatch = async () => {
        try {
            const {filters, listMaterials} = this.state
            let payload = Object.assign({}, filters)

            if (!!filters.name && filters.name.length > 0 && filters.name[0] !== '') {
                payload = Object.assign(payload, {name: {'$in': filters.name}})
            }

            let arrMaterial = []
            if(!!filters.materials && Array.isArray(filters.materials) && filters.materials.length){
                filters.materials.forEach(item => {
                    const material = listMaterials.find(i => i.name === item) || {}
                    const code = !!material.code ? material.code : ''
                    arrMaterial.push(`${code} - ${item}`)
                })

                arrMaterial.push(...filters.materials)
            }else{
                arrMaterial.push(filters.materials)
            }

            if(!!arrMaterial && arrMaterial.length) payload.materials = arrMaterial

            const newFilter = _convertObject(payload)
            const query = queryString.stringify(newFilter)

            const { data } = await exportBatchItems(query)

            if (data) {
                downloadFileFromData(data, { filename: `item-batch${moment().format('HH_mm_DD_MM_YYYY')}.csv` })
            }
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    _exportBatchs = async () => {
        try {
            const {filters, listMaterials} = this.state
            let payload = Object.assign({}, filters)

            if (!!filters.name && filters.name.length > 0 && filters.name[0] !== '') {
                payload = Object.assign(payload, {name: {'$in': filters.name}})
            }

            let arrMaterial = []
            if(!!filters.materials && Array.isArray(filters.materials) && filters.materials.length){
                filters.materials.forEach(item => {
                    const material = listMaterials.find(i => i.name === item) || {}
                    const code = !!material.code ? material.code : ''
                    arrMaterial.push(`${code} - ${item}`)
                })

                arrMaterial.push(...filters.materials)
            }else{
                arrMaterial.push(filters.materials)
            }

            if(!!arrMaterial && arrMaterial.length) payload.materials = arrMaterial

            const newFilter = _convertObject(payload)
            const query = queryString.stringify(newFilter)
            const { data } = await exportBatchs(query)

            if (data) {
                downloadFileFromData(data, { filename: `batch${moment().format('HH_mm_DD_MM_YYYY')}.csv` })
            }
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    _exportBatchsQuantity = async () => {
        try {
            const {filters, listMaterials} = this.state
            let payload = Object.assign({}, filters)

            if (!!filters.name && filters.name.length > 0 && filters.name[0] !== '') {
                payload = Object.assign(payload, {name: {'$in': filters.name}})
            }

            let arrMaterial = []
            if(!!filters.materials && Array.isArray(filters.materials) && filters.materials.length){
                filters.materials.forEach(item => {
                    const material = listMaterials.find(i => i.name === item) || {}
                    const code = !!material.code ? material.code : ''
                    arrMaterial.push(`${code} - ${item}`)
                })

                arrMaterial.push(...filters.materials)
            }else{
                arrMaterial.push(filters.materials)
            }
            
            if(!!arrMaterial && arrMaterial.length) payload.materials = arrMaterial

            const newFilter = _convertObject(payload)
            const query = queryString.stringify(newFilter)

            const { data } = await exportBatchItemQuantity(query)

            if (data) {
                downloadFileFromData(data, { filename: `batch-quantity-${moment().format('HH_mm_DD_MM_YYYY')}.csv` })
            }
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    render() {
        const {batches, error, page, total, limit, loading, filters, status, listBrand, total_items_without_moved, listMaterials} = this.state
        const newFilter = _convertObject(filters)
        const notMovedTotal = !!total_items_without_moved ? (total_items_without_moved > 1 ? `(${total_items_without_moved} items)` : `(${total_items_without_moved} item)`) : '' 

        return (
            <div className='LabelPage BatchesPage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className="mt-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h3 className='m-0'>Danh sách Lô </h3>
                                <div>
                                    {/* <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/batch-reproduction"
                                    >
                                        Lỗi QC sau ép
                                    </Link> */}
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/item-reproduction"
                                    >
                                        Lỗi QC hoàn thành
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/item-piece-error"
                                    >
                                        Item bù chi tiết
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/odd-batch"
                                    >
                                        Lô lẻ
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary ${(total > 5000 || loading || total === 0) ? 'disabled' : ''}`}
                                        to={{
                                            pathname: "/static-batches",
                                            search: queryString.stringify(newFilter)
                                        }}
                                    >
                                        Xem chi tiết
                                    </Link>
                                    <Link
                                        className={`ant-btn mr-3 ant-btn-primary`}
                                        to="/items-error"
                                    >
                                        Items lỗi
                                    </Link>
                                    <Button type="primary" onClick={this._exportAllItemBatch} className='mr-3'>
                                        Export item
                                    </Button>
                                    <Button type="primary" onClick={this._exportBatchs} className='mr-3'>
                                        Export lô
                                    </Button>
                                    <Button type="primary" onClick={this._exportBatchsQuantity}>
                                        Export số lượng item
                                    </Button>
                                </div>
                            </div>

                            <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                                <BatchesFilters
                                    filters={filters}
                                    loading={loading}
                                    listBrand={listBrand}
                                    listMaterials={listMaterials}
                                    handleChangeInput={this._handleChangeInput}
                                    handleChangeDate={this._handleChangeDate}
                                    onChangeProductType={this._handleChangeProductType}
                                    onChangeMaterials={this._handleChangeMaterials}
                                    {...this.props}
                                />
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                                <div>
                                    {error && (
                                        <div className="text-danger mb-2">{error}</div>
                                    )}
                                </div>
                                <Pagination current={page} total={total} pageSize={limit}
                                            showTotal={(sum, range) => sum > 0 &&
                                                <div>
                                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}
                                                    <strong>
                                                        {`${total} lô hàng ${notMovedTotal}`}
                                                    </strong>
                                                </div>}
                                            onChange={this._handlePageChange}
                                            className='text-right' showSizeChanger
                                            pageSizeOptions={['10', '20', '50', '100', '200']}
                                            onShowSizeChange={this._handleShowSizeChange}/>
                            </div>
                            <div className="BatchesTable">
                                <BatchesTable
                                    status={status}
                                    batches={batches}
                                    loading={loading}
                                    refreshBatches={this._fetchBatches}
                                    onChangeProductType={this._handleChangeProductType}
                                    onChangeMaterials={this._handleChangeMaterials}
                                    handleChangeInput={this._handleChangeInput}
                                    filters={newFilter}
                                />
                            </div>
                            <Pagination
                                current={page} total={total} pageSize={limit}
                                onChange={this._handlePageChange}
                                showQuickJumper
                                className='CustomPagination text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100','200']}
                                onShowSizeChange={this._handleShowSizeChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default BatchesPage
